import React from 'react'
import './css/FooterComponent.css'
import { useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import { MAIN } from '../../../config/routes'
import { TEAM, PUBLICATIONS, NEWS } from '../../../config/routeType'

const FooterComponent = () => {
  const navigate = useNavigate()
  return (
    <footer id="footer" className="footer dark-background">
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <Box
              onClick={() => navigate(MAIN)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                fontSize: 32,
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: 600,
                lineHeight: '48px',
                textAlign: 'start',
              }}>
              <span className="sitename">
                Árbol<span style={{ color: 'rgb(43, 174, 86)' }}>Ec</span>
              </span>
              <Typography sx={{ fontSize: '15px' }}>
                Universidad Nacional de Loja
              </Typography>
            </Box>
            <div className="footer-contact pt-3">
              <p>Av. Pio Jaramillo Alvarado y </p>
              <p>Av. Reinaldo Espinosa, 110103.</p>
              <p>
                <strong>Teléfono:</strong> <span>+593 99 653 3131 | +593 98 811 8716 (Dirección)</span>
              </p>
              <p>
                <strong>Email:</strong> <span>arbolec@unl.edu.ec</span>
              </p>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Inicios Rapidos</h4>
            <ul>
              <li>
                <i className="bi bi-chevron-right"></i>
                {/* eslint-disable-next-line */}
                <a href={MAIN}>Incio</a>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>
                {/* eslint-disable-next-line */}
                <a href={`/${TEAM}`}>Equipo de trabajo</a>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>
                {/* eslint-disable-next-line */}
                <a href={`/${PUBLICATIONS}`}>Publicaciones</a>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>
                {/* eslint-disable-next-line */}
                <a href={`/${NEWS}`}>Noticias</a>
              </li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 footer-links"></div>

          <div className="col-lg-4 col-md-12">
            <h4>Siguenos</h4>
            <div className="social-links d-flex">
              {/* eslint-disable-next-line */}
              <a
                href="https://x.com/UNLoficial"
                target="_blank"
                rel="noopener noreferrer">
                <i className="bi bi-twitter-x"></i>
              </a>
              {/* eslint-disable-next-line */}
              <a
                href="https://www.facebook.com/UNLoficial/"
                target="_blank"
                rel="noopener noreferrer">
                <i className="bi bi-facebook"></i>
              </a>
              {/* eslint-disable-next-line */}
              <a
                href="https://www.instagram.com/unloficial/"
                target="_blank"
                rel="noopener noreferrer">
                <i className="bi bi-instagram"></i>
              </a>
              {/* eslint-disable-next-line */}
              <a
                href="https://www.linkedin.com/school/universidad-nacional-de-loja/"
                target="_blank"
                rel="noopener noreferrer">
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>© 2025. Universidad Nacional de Loja. Todos los derechos reservados.</p>
      </div>
    </footer>
  )
}

export default FooterComponent
